export const gitAuthIdentifiers = ["githubApp", "gitlab", "gitlabOAuth"];

const GIT_AUTH_IDENTIFIERS = new Set(gitAuthIdentifiers);

export function supportsGitAuth(identifier: string): boolean {
  return GIT_AUTH_IDENTIFIERS.has(identifier);
}

// GitHub Apps register their webhook at app creation; GitLab hooks are added
// per project by hand.
const MANUAL_WEBHOOK_IDENTIFIERS = new Set(["gitlab", "gitlabOAuth"]);

export function supportsManualGitWebhook(identifier: string): boolean {
  return MANUAL_WEBHOOK_IDENTIFIERS.has(identifier);
}
